export default __webpack_public_path__ + "static/media/Warning.01c2c7fa.svg";